import { updateConfigSettings } from "../../../actions/siteadmin/ConfigSettings/updateConfigSettings";
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
   const isRestrict = await dispatch(demoRestriction({}));
   if (isRestrict) return;
   await dispatch(updateConfigSettings(values))
}

export default submit;